var _path, _path2, _polygon, _path3, _polygon2, _path4, _path5, _path6, _circle, _path7, _path8, _path9, _polygon3, _polygon4, _path10, _rect, _rect2, _rect3, _rect4, _path11, _path12, _path13, _path14, _path15, _rect5, _rect6, _rect7, _rect8, _path16, _rect9, _rect10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 782.40551,
    height: 665.60645,
    viewBox: "0 0 782.40551 665.60645",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M896.6662,758.041c8.5549,16.62823,27.251,24.0573,27.251,24.0573s4.82585-19.53065-3.72905-36.15887-27.251-24.0573-27.251-24.0573S888.11131,741.41281,896.6662,758.041Z",
    transform: "translate(-208.79724 -117.19678)",
    fill: "#f1f1f1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M902.8702,752.74513c15.83378,9.94863,21.63305,29.21269,21.63305,29.21269s-19.8724,3.1341-35.70619-6.81453S867.164,745.9306,867.164,745.9306,887.03639,742.79647,902.8702,752.74513Z",
    transform: "translate(-208.79724 -117.19678)",
    fill: "#f1f1f1"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "471.576 653.39 460.472 653.39 455.19 610.561 471.578 610.562 471.576 653.39",
    fill: "#ffb7b7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M683.20458,781.35011l-35.803-.00133v-.45285a13.93627,13.93627,0,0,1,13.93552-13.9353h.00089l21.86726.00088Z",
    transform: "translate(-208.79724 -117.19678)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "540.409 653.39 529.305 653.39 524.023 610.561 540.411 610.562 540.409 653.39",
    fill: "#ffb7b7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M752.03778,781.35011l-35.803-.00133v-.45285a13.93627,13.93627,0,0,1,13.93553-13.9353h.00088l21.86726.00088Z",
    transform: "translate(-208.79724 -117.19678)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M716.96372,529.3459,695.11681,485.382l5.62657-36.4662-26.2653-7.2456L671.761,490.578l34.06148,46.28876a9.05261,9.05261,0,1,0,11.14126-7.52083Z",
    transform: "translate(-208.79724 -117.19678)",
    fill: "#ffb7b7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M764.22463,529.3459,786.07154,485.382l-5.62657-36.4662,26.2653-7.2456,2.7171,48.9078-34.06148,46.28876a9.05261,9.05261,0,1,1-11.14126-7.52083Z",
    transform: "translate(-208.79724 -117.19678)",
    fill: "#ffb7b7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 540.84552,
    cy: 238.00072,
    r: 23.89528,
    fill: "#ffb9b9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M725.92823,355.06948s-2.59259-3.88886-1.59543-8.07689a24.48,24.48,0,0,0,.698-7.27917,72.04546,72.04546,0,0,1,4.188-10.56975c2.094-3.78917,1.09686-5.3846,7.678-6.58117s3.88889-9.772,21.23923-.49858a5.0883,5.0883,0,0,0,5.28489,1.99429c3.58972-.698,4.886,4.28773,4.886,4.28773s2.39316-1.396,3.2906.59829,7.29626-1.19692,7.29626,12.26456-7.28172,25.48606-7.28172,25.48606-5.1136,16.134-16.97963,13.84058-13.5855-.9057-21.73679-16.3026C731.22711,369.04583,728.66523,350.7732,725.92823,355.06948Z",
    transform: "translate(-208.79724 -117.19678)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M697.12058,509.59767,694.35,520.461s-13.04915,6.30568-18.27193,62.93158l-7.03418,84.90584L658.3077,757.27955l22.31773,1.73147,15.47517-56.37388,33.43262-118.53385,6.3399,89.6721-7.053,81.267,23.54819.9057,16.3026-90.57s24.9745-132.66142,8.86445-136.52245l-1.61885-13.82373Z",
    transform: "translate(-208.79724 -117.19678)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M691.95381,407.49181l38.44175-21.18411,32.62515,1.74121,38.96851,23.0657-16.242,101.43193s9.31017,10.40866-18.82715,7.35269-73.61486-5.53483-73.61486-5.53483-3.65768-7.25742,4.15449-8.27632,1.27971-.78068,1.27971-.78068-4.721-15.15866,0-18.114l2.284-31.13226Z",
    transform: "translate(-208.79724 -117.19678)",
    fill: "#3f3d56"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "493.758 291.868 483.157 290.295 460.699 330.36 497.188 346.448 493.758 291.868",
    fill: "#3f3d56"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "580.705 299.114 593.192 293.918 605.611 350.286 571.908 356.669 580.705 299.114",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M501.20276,782.80322h489a1,1,0,0,0,0-2h-489a1,1,0,1,0,0,2Z",
    transform: "translate(-208.79724 -117.19678)",
    fill: "#cbcbcb"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 397.60645,
    width: 127,
    height: 64,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 128.00492,
    y: 413.9894,
    width: 96.99016,
    height: 3.28781,
    fill: "#00b8e4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 128.00492,
    y: 427.96253,
    width: 96.99016,
    height: 3.28781,
    fill: "#00b8e4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 128.00492,
    y: 441.93568,
    width: 96.99016,
    height: 3.28781,
    fill: "#00b8e4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M449.79724,579.80322h-129v-66h129Zm-127-2h125v-62h-125Z",
    transform: "translate(-208.79724 -117.19678)",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M357.5347,435.31175A144.4396,144.4396,0,0,1,281.423,413.7047l-.58075-.3598.35913-.58074,75.95212-122.92238H502.32046v.68354C502.32046,370.36109,437.36979,435.31175,357.5347,435.31175Z",
    transform: "translate(-208.79724 -117.19678)",
    fill: "#00b8e4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M264.39766,383.11878,263.931,382.83a116.25841,116.25841,0,0,1-39.82172-156.52455l.27243-.47547,101.40059,57.943Z",
    transform: "translate(-208.79724 -117.19678)",
    fill: "#f1f1f1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M502.32046,270.44823H356.6836l31.39562-142.23216.66685.14652A144.83118,144.83118,0,0,1,502.32046,269.76468Z",
    transform: "translate(-208.79724 -117.19678)",
    fill: "#00b8e4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M333.48684,248.04719,234.80924,191.66l.26523-.463a113.04267,113.04267,0,0,1,122.38838-54.243l.52108.11453Z",
    transform: "translate(-208.79724 -117.19678)",
    fill: "#f1f1f1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 367.00394,
    y: 1.00015,
    width: 127,
    height: 64,
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 382.00885,
    y: 17.3831,
    width: 96.99016,
    height: 3.28781,
    fill: "#00b8e4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 382.00885,
    y: 31.35623,
    width: 96.99016,
    height: 3.28781,
    fill: "#00b8e4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 382.00885,
    y: 45.32938,
    width: 96.99016,
    height: 3.28781,
    fill: "#00b8e4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M703.80115,183.19678h-129v-66h129Zm-127-2h125v-62h-125Z",
    transform: "translate(-208.79724 -117.19678)",
    fill: "#3f3d56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 175.77173,
    y: 231.96875,
    width: 2,
    height: 164.6377,
    fill: "#3f3d56"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 418.25662,
    y: 184.13696,
    width: 164.78461,
    height: 2,
    transform: "translate(-240.60342 105.57799) rotate(-24.33745)",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysis);
export default __webpack_public_path__ + "static/media/analysis.487b3175e6829b197dce6a38f8c34c7e.svg";
export { ForwardRef as ReactComponent };